import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ISetting, ISettingsResponse, SettingType } from "../models/Setting";
import { IReportsResponse } from "../models/report/Report";
import { apiFileRequestTimeoutMs } from "../config";

export default function useReports() {
  const { get, post, put, del } = useApiHelper();
  // Running a report can return a large result set and take a while, so use the
  // longer "long-running" request timeout rather than the default JSON timeout.
  const { post: postLongRunning } = useApiHelper({ timeoutMs: apiFileRequestTimeoutMs });
  const queryClient = useQueryClient();

  const reports = useQuery({
    queryKey: ["reports"],
    queryFn: () => get<IReportsResponse>("/report"),
  });

  const runReport = useMutation(
    (body: any) => postLongRunning(`/report/${body.id}`, body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["reports"]);
      },
    }
  );


  return {
    reports,
    runReport
  };
}
